import { IProduct } from "./products.interface";


export interface ICartProduct {
  product: IProduct;
  size: string | null;
  color: string | null;
  count: number;
  comment: string | null;
  product_offer_id?:string; 
}